import { useContext } from 'react';

import AddressTypeData from './AddressTypeData';
import { AddressTypeStateContext } from './AddressTypeContextProvider';

import { NO_DATA_MESSAGE } from '../../utils/HttpHelper';

const useAddressTypeData = () => {
  const [addressTypeState, setAddressTypeState] = useContext(AddressTypeStateContext);

  const getAddressTypes = async () => {
    const getAddressTypesResult = await AddressTypeData.getAddressTypesData(addressTypeState, setAddressTypeState);

    if (getAddressTypesResult.arrayData) {
      getAddressTypesResult.arrayData.sort((a, b) => {
        if (a.typeName === 'Current') return -1;
        if (b.typeName === 'Current') return 1;
        return 0;
      });

      let newState = {
        ...getAddressTypesResult,
        options: getAddressTypesResult.arrayData.map((x) => { return { id: x.addressTypeId, name: createAddressOptionName(x) } }),
        optionsStandardOnly: getAddressTypesResult.arrayData.filter((x) => x.isNationalTeamOnly !== true).map((x) => { return { id: x.addressTypeId, name: createAddressOptionName(x) } }),
        optionsNationalTeamOnly: getAddressTypesResult.arrayData.filter((x) => x.isNationalTeamOnly === true).map((x) => { return { id: x.addressTypeId, name: createAddressOptionName(x) } }),
        areOptionsLoaded: true
      };

      setAddressTypeState({ ...newState });

      return newState;
    } else {
      throw new Error(NO_DATA_MESSAGE);
    }
  };

  function createAddressOptionName(addressType) {
    if (addressType.typeDescription) {
      return `${addressType.typeName} (${addressType.typeDescription})`;
    } else {
      return addressType.typeName;
    }
  }

  return {
    addressTypeState,
    getAddressTypes
  };
};

export default useAddressTypeData;